import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModalModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { AppShellNoRenderDirective } from "../directives/app-shell-norender.directive";
import { AppShellRenderDirective } from "../directives/app-shell-render.directive";
import { LazyLoadDirective } from "../directives/lazy-load.directive";
import { FormateUrlPipe } from "../pipe/formate-url.pipe";
import { SafePipe } from "../SafePipe";
import { ConfirmationBoxComponent } from "./components/confirmation-box/confirmation-box.component";
import { FullLayoutComponent } from "./components/fulllayout.component";
import { HowItWorksComponent } from "./components/howitworks/howitworks.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { LoginComponent } from "./components/Login/Login.component";
import { MainFooterComponent } from "./components/main-footer/main-footer.component";
import { MainHeaderComponent } from "./components/main-header/main-header.component";
import { NumberDirective } from "./directive/number-only.directive";
import { TwoDigitDecimaNumberDirective } from "./directive/two-digit-decimal-number.directive";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { VideoEditorComponent } from './components/video-editor/video-editor.component';
import { CardEditorComponent } from './components/card-editor/card-editor.component';

@NgModule({
    declarations: [
        LoaderComponent,
        NumberDirective,
        TwoDigitDecimaNumberDirective,
        MainHeaderComponent,
        MainFooterComponent,
        FullLayoutComponent,

        SafePipe,
        HowItWorksComponent,
        ConfirmationBoxComponent,
        FormateUrlPipe,
        AppShellNoRenderDirective,
        AppShellRenderDirective,
        LazyLoadDirective,
        VideoEditorComponent,
        CardEditorComponent

    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot(),
        NgbModule,
        NgbModalModule,
        ReactiveFormsModule,
        RouterModule,
        PdfViewerModule
    ],
    providers: [],
    entryComponents: [ConfirmationBoxComponent],
    exports: [
        LoaderComponent,
        CardEditorComponent,
        NumberDirective,
        TwoDigitDecimaNumberDirective,
        MainHeaderComponent,
        MainFooterComponent,
        FullLayoutComponent,
        SafePipe,
        HowItWorksComponent,
        ConfirmationBoxComponent,
        FormateUrlPipe,
        AppShellNoRenderDirective,
        AppShellRenderDirective,
        LazyLoadDirective,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgbModalModule,
        RouterModule,
        PdfViewerModule]
})
export class SharedModule { }